function normalizeFiniteNumber(value) {
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}

function readMetricValue(observationOrValue) {
  if (typeof observationOrValue === "number" && Number.isFinite(observationOrValue)) {
    return observationOrValue;
  }

  return normalizeFiniteNumber(observationOrValue?.value);
}

export function getEnvironmentalMetricValueClass(metricKey, observationOrValue) {
  const value = readMetricValue(observationOrValue);

  if (value === null) {
    return "text-typography";
  }

  switch (metricKey) {
    case "aqi":
      if (value >= 80) {
        return "text-emerald-700";
      }
      if (value >= 60) {
        return "text-lime-700";
      }
      if (value >= 40) {
        return "text-amber-700";
      }
      if (value >= 20) {
        return "text-orange-700";
      }
      return "text-red-700";
    case "temperature":
      if (value < 10) {
        return "text-sky-700";
      }
      if (value < 20) {
        return "text-primary";
      }
      if (value < 28) {
        return "text-amber-700";
      }
      return "text-red-700";
    case "humidity":
      if (value < 30) {
        return "text-amber-700";
      }
      if (value <= 70) {
        return "text-emerald-700";
      }
      return "text-sky-700";
    case "pressure":
      return "text-primary";
    case "pollen":
      if (value <= 1) {
        return "text-emerald-700";
      }
      if (value <= 2) {
        return "text-lime-700";
      }
      if (value <= 3) {
        return "text-amber-700";
      }
      if (value <= 4) {
        return "text-orange-700";
      }
      return "text-red-700";
    default:
      return "text-typography";
  }
}
